export const KvackicaStatistics = () => {
  return (
    <div className="mainDiv">
      <div className="header">Kvačkica</div>
      <div className="graphs  loading-container">
        <div className="graphs-header">
          <span>
            <div className="color7"></div>Kvačkica iznos
          </span>
        </div>
        <div className="graphs-content loading-container"></div>
      </div>
    </div>
  );
};
